import routerOptions0 from "/home/forge/oase-aej.de/releases/81992485/client/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/forge/oase-aej.de/releases/81992485/client/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}